<template>
  <div class="thirdList">
    <search-input @search="handleSearch"></search-input>
    <div class="list">
      <list-item
        @click="togglePage('thirdDetail', item)"
        v-for="item in serviceList"
        :key="item.id"
        :item="item"
      ></list-item>
    </div>
  </div>
</template>

<script>
import { getServiceList } from "@/api/service.js";
import { areaCode } from "@/common/constants.js";
export default {
  name: "thirdList",
  data() {
    return {
      form: {
        areaCode,
        openId: "",
        serviceNature: "p_party ",
        serviceName: ""
      },
      serviceList: []
    };
  },
  methods: {
    togglePage(name, item) {
      this.$router.push({
        name,
        query: { id: item.id, serviceName: item.serviceName }
      });
    },
    async getData() {
      const { list } = await getServiceList(this.form);
      this.serviceList = list;
    },
    handleSearch(val) {
      this.form.serviceName = val;
      this.getData();
    }
  },
  mounted() {
    this.form.openId = this.$store.state.user.openId;
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.thirdList {
  .list {
  }
}
</style>
